import React from 'react';

interface IMethodSVGRender {
  method: any;
}

const MethodSVGRender: React.FC<IMethodSVGRender> = ({ method }) => {
  return (
    <div className='card-row-icon'>
      {!method?.card ? (
        <div className='pay-method-modal-item-icon'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
          >
            <path
              d='M5 9.00002V17M9.5 9.00002V17M14.5 9.00002V17M19 9.00002V17M3 18.6L3 19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7952 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7952 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.04 21 17.7599 20.891 17.546C20.7951 17.3579 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3579 3.10899 17.546C3 17.7599 3 18.04 3 18.6ZM11.6529 3.07715L4.25291 4.7216C3.80585 4.82094 3.58232 4.87062 3.41546 4.99082C3.26829 5.09685 3.15273 5.24092 3.08115 5.40759C3 5.59654 3 5.82553 3 6.28349L3 7.40002C3 7.96007 3 8.2401 3.10899 8.45401C3.20487 8.64217 3.35785 8.79515 3.54601 8.89103C3.75992 9.00002 4.03995 9.00002 4.6 9.00002H19.4C19.9601 9.00002 20.2401 9.00002 20.454 8.89103C20.6422 8.79515 20.7951 8.64217 20.891 8.45401C21 8.2401 21 7.96007 21 7.40002V6.2835C21 5.82553 21 5.59655 20.9188 5.40759C20.8473 5.24092 20.7317 5.09685 20.5845 4.99082C20.4177 4.87062 20.1942 4.82094 19.7471 4.7216L12.3471 3.07715C12.2176 3.04837 12.1528 3.03398 12.0874 3.02824C12.0292 3.02314 11.9708 3.02314 11.9126 3.02824C11.8472 3.03398 11.7824 3.04837 11.6529 3.07715Z'
              stroke='var(--text-primary)'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>
      ) : (
        <>
          {method?.card && method.card.brand === 'visa' && (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='46'
              height='32'
              viewBox='0 0 46 32'
              fill='none'
            >
              <path
                d='M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z'
                fill='white'
              />
              <path
                d='M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z'
                stroke='#EAECF0'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.3337 21.1441H11.5874L9.52796 13.0563C9.43022 12.6843 9.22267 12.3554 8.91737 12.2003C8.15547 11.8108 7.31591 11.5007 6.40002 11.3444V11.033H10.8241C11.4347 11.033 11.8927 11.5007 11.969 12.044L13.0375 17.878L15.7825 11.033H18.4525L14.3337 21.1441ZM19.979 21.1441H17.3853L19.521 11.033H22.1147L19.979 21.1441ZM25.4703 13.8341C25.5466 13.2895 26.0046 12.9781 26.5388 12.9781C27.3784 12.8999 28.2929 13.0563 29.0562 13.4445L29.5141 11.2676C28.7509 10.9562 27.9113 10.7998 27.1494 10.7998C24.6321 10.7998 22.8003 12.2003 22.8003 14.1441C22.8003 15.6228 24.0978 16.3993 25.0137 16.867C26.0046 17.3334 26.3862 17.6448 26.3099 18.1112C26.3099 18.8108 25.5466 19.1222 24.7847 19.1222C23.8688 19.1222 22.9529 18.889 22.1147 18.4994L21.6568 20.6777C22.5727 21.066 23.5635 21.2223 24.4794 21.2223C27.3021 21.2992 29.0562 19.9 29.0562 17.7998C29.0562 15.1551 25.4703 15.0001 25.4703 13.8341V13.8341ZM38.1334 21.1441L36.074 11.033H33.8619C33.404 11.033 32.946 11.3444 32.7934 11.8108L28.9798 21.1441H31.6498L32.1828 19.6668H35.4634L35.7687 21.1441H38.1334ZM34.2435 13.7559L35.0054 17.5666H32.8697L34.2435 13.7559Z'
                fill='#172B85'
              />
            </svg>
          )}
          {method?.card && method.card.brand === 'mastercard' && (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='46'
              height='32'
              viewBox='0 0 46 32'
              fill='none'
            >
              <path
                d='M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z'
                fill='white'
              />
              <path
                d='M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z'
                stroke='#EAECF0'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M22.9053 22.4392C21.3266 23.7699 19.2787 24.5732 17.0409 24.5732C12.0478 24.5732 8 20.5736 8 15.6399C8 10.7061 12.0478 6.70654 17.0409 6.70654C19.2787 6.70654 21.3266 7.50987 22.9053 8.8406C24.484 7.50987 26.5319 6.70654 28.7697 6.70654C33.7628 6.70654 37.8106 10.7061 37.8106 15.6399C37.8106 20.5736 33.7628 24.5732 28.7697 24.5732C26.5319 24.5732 24.484 23.7699 22.9053 22.4392Z'
                fill='#ED0006'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M22.9053 22.4392C24.8492 20.8006 26.0818 18.3625 26.0818 15.6399C26.0818 12.9173 24.8492 10.4791 22.9053 8.8406C24.484 7.50987 26.5319 6.70654 28.7697 6.70654C33.7628 6.70654 37.8106 10.7061 37.8106 15.6399C37.8106 20.5736 33.7628 24.5732 28.7697 24.5732C26.5319 24.5732 24.484 23.7699 22.9053 22.4392Z'
                fill='#F9A000'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M22.9053 22.4393C24.8492 20.8008 26.0818 18.3627 26.0818 15.6401C26.0818 12.9175 24.8492 10.4794 22.9053 8.84082C20.9614 10.4794 19.7288 12.9175 19.7288 15.6401C19.7288 18.3627 20.9614 20.8008 22.9053 22.4393Z'
                fill='#FF5E00'
              />
            </svg>
          )}
          {method?.card && method.card.brand === 'discover' && (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='46'
              height='32'
              viewBox='0 0 46 32'
              fill='none'
            >
              <path
                d='M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z'
                fill='white'
              />
              <path
                d='M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z'
                stroke='#EAECF0'
              />
              <path
                d='M25 31L44 25.25V28C44 29.6569 42.6569 31 41 31H25Z'
                fill='#FD6020'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M39.1916 12.1478C40.5853 12.1478 41.3518 12.7925 41.3518 14.0103C41.4215 14.9416 40.7943 15.7296 39.9581 15.8729L41.8396 18.5234H40.3762L38.7734 15.9445H38.6341V18.5234H37.4494V12.1478H39.1916ZM38.6341 15.0849H38.9825C39.749 15.0849 40.0975 14.7267 40.0975 14.082C40.0975 13.5089 39.749 13.1507 38.9825 13.1507H38.6341V15.0849ZM33.3379 18.5234H36.6829V17.4488H34.5226V15.7296H36.6132V14.655H34.5226V13.2223H36.6829V12.1478H33.3379V18.5234V18.5234ZM29.8536 16.4459L28.2508 12.1478H26.9965L29.5749 18.6667H30.202L32.7804 12.1478H31.5261L29.8536 16.4459V16.4459ZM15.7073 15.3714C15.7073 17.1623 17.101 18.6667 18.8432 18.6667C19.4007 18.6667 19.8885 18.5234 20.3763 18.3085V16.8758C20.0279 17.3056 19.5401 17.5921 18.9826 17.5921C17.8676 17.5921 16.9617 16.7325 16.9617 15.5863V15.4431C16.892 14.2969 17.7979 13.294 18.9129 13.2223C19.4704 13.2223 20.0279 13.5089 20.3763 13.9387V12.506C19.9582 12.2194 19.4007 12.1478 18.9129 12.1478C17.101 12.0045 15.7073 13.5089 15.7073 15.3714V15.3714ZM13.547 14.5834C12.8502 14.2969 12.6411 14.1536 12.6411 13.7954C12.7108 13.3656 13.0592 13.0074 13.4773 13.0791C13.8258 13.0791 14.1742 13.294 14.4529 13.5805L15.0801 12.7209C14.5923 12.2911 13.9651 12.0045 13.338 12.0045C12.3624 11.9329 11.5261 12.7209 11.4564 13.7238V13.7954C11.4564 14.6551 11.8049 15.1565 12.9198 15.5147C13.1986 15.5863 13.4773 15.7296 13.7561 15.8729C13.9651 16.0161 14.1045 16.231 14.1045 16.5176C14.1045 17.019 13.6864 17.4489 13.2683 17.4489H13.1986C12.6411 17.4489 12.1533 17.0907 11.9442 16.5892L11.1777 17.3772C11.5958 18.1652 12.432 18.595 13.2683 18.595C14.3833 18.6667 15.2892 17.807 15.3589 16.6609V16.446C15.2892 15.5863 14.9407 15.1565 13.547 14.5834V14.5834ZM9.50522 18.5234H10.6899V12.1478H9.50522V18.5234V18.5234ZM4 12.1478H5.74216H6.09059C7.76306 12.2194 9.0871 13.6522 9.01741 15.3714C9.01741 16.3027 8.59929 17.1623 7.90243 17.807C7.27526 18.3085 6.50871 18.595 5.74216 18.5234H4V12.1478ZM5.5331 17.4488C6.09059 17.5205 6.71776 17.3056 7.13588 16.9474C7.554 16.5176 7.76306 15.9445 7.76306 15.2998C7.76306 14.7267 7.554 14.1536 7.13588 13.7238C6.71776 13.3656 6.09059 13.1507 5.5331 13.2223H5.18466V17.4488H5.5331Z'
                fill='black'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M23.9303 12C22.1881 12 20.7247 13.4327 20.7247 15.2953C20.7247 17.0862 22.1185 18.5905 23.9303 18.6621C25.7421 18.7338 27.1359 17.2294 27.2056 15.3669C27.1359 13.5044 25.7421 12 23.9303 12V12Z'
                fill='#FD6020'
              />
            </svg>
          )}
          {method.card.brand === 'amex' && (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='46'
              height='32'
              viewBox='0 0 46 32'
              fill='none'
            >
              <path
                d='M0 4C0 1.79086 1.79086 0 4 0H42C44.2091 0 46 1.79086 46 4V28C46 30.2091 44.2091 32 42 32H4C1.79086 32 0 30.2091 0 28V4Z'
                fill='#1F72CD'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.12722 11.3335L3.88574 20.9958H8.96339L9.59287 19.4552H11.0317L11.6612 20.9958H17.2503V19.82L17.7483 20.9958H20.6394L21.1374 19.7952V20.9958H32.7611L34.1745 19.4953L35.498 20.9958L41.4682 21.0082L37.2133 16.1916L41.4682 11.3335H35.5906L34.2147 12.8063L32.9329 11.3335H20.2878L19.202 13.8274L18.0907 11.3335H13.0237V12.4693L12.46 11.3335H8.12722ZM9.10972 12.7056H11.5848L14.3982 19.2576V12.7056H17.1095L19.2825 17.4034L21.2852 12.7056H23.983V19.6389H22.3415L22.3281 14.206L19.9348 19.6389H18.4664L16.0598 14.206V19.6389H12.6827L12.0425 18.0845H8.58358L7.94468 19.6376H6.1353L9.10972 12.7056ZM32.1598 12.7056H25.4849V19.6348H32.0564L34.1745 17.3384L36.2161 19.6348H38.3502L35.2483 16.1903L38.3502 12.7056H36.3087L34.2013 14.9757L32.1598 12.7056ZM10.3138 13.8786L9.17419 16.6476H11.452L10.3138 13.8786ZM27.1332 15.4068V14.1411V14.1399H31.2982L33.1155 16.164L31.2176 18.1993H27.1332V16.8175H30.7747V15.4068H27.1332Z'
                fill='white'
              />
            </svg>
          )}
          {method?.card &&
            method?.card?.brand !== 'visa' &&
            method?.card?.brand !== 'mastercard' &&
            method?.card?.brand !== 'discover' &&
            method?.card?.brand !== 'amex' && (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='48'
              height='34'
              viewBox='0 0 48 34'
              fill='none'
            >
              <path
                d='M47 12.4286H1M1 8.31429L1 25.6857C1 28.246 1 29.5261 1.50137 30.504C1.94239 31.3641 2.6461 32.0635 3.51164 32.5017C4.49564 33 5.78376 33 8.36 33L39.64 33C42.2162 33 43.5044 33 44.4884 32.5017C45.3539 32.0635 46.0576 31.3641 46.4986 30.504C47 29.5261 47 28.246 47 25.6857V8.31429C47 5.75405 47 4.47393 46.4986 3.49605C46.0576 2.63588 45.3539 1.93654 44.4884 1.49826C43.5044 1 42.2162 1 39.64 1L8.36 1C5.78376 1 4.49564 1 3.51164 1.49826C2.6461 1.93653 1.94239 2.63587 1.50137 3.49604C1 4.47393 1 5.75405 1 8.31429Z'
                stroke='var(--text-primary)'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          )}
        </>
      )}
    </div>
  );
};

export default MethodSVGRender;
